import React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { useAppSelector } from '../../../app/hooks'
import { sectionApiSlice } from '../../../features/section/sectionSlice'
import Breadcrumb from '../../../components/Breadcrumb'
import GroupsTable from './components/GroupsTable'

const GroupListPage = () => {
    const { formatMessage } = useIntl()
    const { id } = useAppSelector((state) => state.user.userInfo)
    const { data: groups = [], isFetching } =
        sectionApiSlice.useGetGroupsSectionAnalysisQuery(id)

    return (
        <Wrapper>
            <Breadcrumb links={[formatMessage({ id: 'groups' })]} />

            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'groups' })}</H3>
                    </Title>
                </Header>

                {isFetching && <LinearProgress />}

                <GroupsTable
                    groups={groups}
                    isFetching={isFetching}
                />
            </Content>
        </Wrapper>
    )
}

export default GroupListPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
